import { SellingMethod, BackendErrorCode, type BackendErrorEntity, type ErrorType } from '~/apiClient';
import { ROUTE_NAMES } from '~/constants/routes';
import type { SaleItemEntity } from '~/types/sale.type';

export type UseSdpParamsCheckerReturnType = void;

const SDP_SALE_CHANNEL_TO_ROUTE_NAME_MAP = {
    [SellingMethod.Auction]: ROUTE_NAMES.AUCTION_DETAIL,
    [SellingMethod.DirectSale]: ROUTE_NAMES.DIRECT_SALE_DETAIL,
};

export const useSdpParamsChecker = (
    sale: Ref<SaleItemEntity | undefined>,
    error: Ref<ErrorType<BackendErrorEntity> | null>,
    isError: Ref<boolean>
): UseSdpParamsCheckerReturnType => {
    const { id, slug } = useSdpParams();
    const localePath = useLocalePath();

    if (slug.value === sale.value?.id) {
        // Redirect to correct slug
        navigateTo(localePath({ name: SDP_SALE_CHANNEL_TO_ROUTE_NAME_MAP[sale.value.sellingMethod], params: { slug: sale.value.slug } }));
    } else if (
        !id.value ||
        error.value?.data?.error.code === BackendErrorCode.EntityNotFound || // backend 404
        error.value?.data?.error.code === BackendErrorCode.InvalidUUID || // backend 400
        slug.value !== sale.value?.slug // Slug is not correct
    ) {
        showError({ statusCode: 404 });
    } else if (isError.value) {
        // Backend 500
        showError({ statusCode: 500 });
    }
};
